<template>
  <div class="content">
    <LinkPath current-path="usuários"/>
    <section class="user-table">


      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="form-group">

              <div class="button-group">

                <div>
                  <a id="newUser" v-on:click="toggleClassByName('show', '#newUserForm'); clearUser(); "
                     class="btn btn-primary new-user-button"
                     data-toggle="collapse" href="#newUserForm" role="button" aria-expanded="false"
                     aria-controls="collapseExample">
                    Novo Usuário
                  </a>
                </div>

                <div class="toggle-button-cover">
                  <div class="button-cover">
                    <div v-on:click="toggleClassByName('show', '#collapseTable'); "
                         class="button-toggle b2" id="button-11" data-toggle="collapse"
                         data-target="#collapseTable" aria-expanded="false"
                         aria-controls="collapseTable"
                    >
                      <input type="checkbox" class="checkbox"/>
                      <div class="knobs">
                        <span></span>
                      </div>
                      <div class="layer"></div>
                    </div>
                  </div>
                </div>

              </div>

              <div id="divAlert" class="alert alert-success" role="alert" style="margin: 16px; display:none;"></div>

              <div class="collapse" id="newUserForm">
                <NewUser/>
              </div>

              <div class="collapse" id="divUser">
                <EditUser :usuario="this.usuario"
                          :right-hand="rightHand"
                          :right-hand-reason="rightHandReason"
                          :right-thumb="rightThumb"
                          :right-thumb-reason="rightThumbReason"
                          :right-index-finger="rightIndexFinger"
                          :right-index-finger-reason="rightIndexFingerReason"
                          :right-middle-finger="rightMiddleFinger"
                          :right-middle-finger-reason="rightMiddleFingerReason"
                          :right-ring-finger="rightRingFinger"
                          :right-ring-finger-reason="rightRingFingerReason"
                          :right-little-finger="rightLittleFinger"
                          :right-little-finger-reason="rightLittleFingerReason"
                          :left-hand="leftHand"
                          :left-hand-reason="leftHandReason"
                          :left-thumb="leftThumb"
                          :left-thumb-reason="leftThumbReason"
                          :left-index-finger="leftIndexFinger"
                          :left-index-finger-reason="leftIndexFingerReason"
                          :left-middle-finger="leftMiddleFinger"
                          :left-middle-finger-reason="leftMiddleFingerReason"
                          :left-ring-finger="leftRingFinger"
                          :left-ring-finger-reason="leftRingFingerReason"
                          :left-little-finger="leftRingFinger"
                          :left-little-finger-reason="leftLittleFingerReason"
                />
              </div>
            </div>

            <div class=".collapse.show" id="collapseTable">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box">

                    <!-- /.box-header -->
                    <div class="box-body">
                      <div class="dataTables_wrapper form-inline dt-bootstrap" id="tabUser_wrapper">
                        <div class="row">
                          <div class="col-sm-6">
                            <div id="tabUser_length" class="dataTables_length">

                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-12 table-responsive">
                            <table aria-describedby="tabUser" role="grid" id="tabUser"
                                   class="table table-bordered table-striped dataTable">
                              <thead>
                              <tr role="row">
                                <th style="width: 10px;" colspan="1" rowspan="1" tabindex="0"></th>
                                <th aria-sort="ascending" style="width: 167px;" colspan="1" rowspan="1"
                                    aria-controls="tabUser" tabindex="0" class="sorting_asc">Usuário
                                </th>
                                <th style="width: 207px;" colspan="1" rowspan="1" aria-controls="tabUser" tabindex="0"
                                    class="sorting">Nome
                                </th>
                                <th style="width: 182px;" colspan="1" rowspan="1" aria-controls="tabUser" tabindex="0"
                                    class="sorting">E-mail
                                </th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="(user, index) in listaUsuario" :key="user.id" class="even" role="row">
                                <td>
                                  <a href="#" id="userEditButton" v-on:click="editUser(index)" title="Editar Usuário"
                                     style="margin-left: 30%;">
                                    <i class="fa fa-fw fa-pencil"></i>
                                  </a>
                                </td>
                                <td class="sorting_1">{{ user.username }}</td>
                                <td>{{ user.name }}</td>
                                <td>{{ user.email }}</td>
                              </tr>
                              </tbody>
                              <tfoot>
                              <tr>
                                <th colspan="1" rowspan="1"></th>
                                <th colspan="1" rowspan="1">Usuário</th>
                                <th colspan="1" rowspan="1">Nome</th>
                                <th colspan="1" rowspan="1">E-mail</th>
                              </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>
                      <!-- /.box-body -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import $ from 'jquery'
import 'datatables.net'
import 'datatables.net-bs'
import interceptor from '../../interceptor'
import Usuario from '../../model/Usuario'
import roles from '../../roles'
import LinkPath from '../components/LinkPath'
import EditUser from '../components/EditUser'
import NewUser from '../components/NewUser'

export default {
  name: 'Usuarios',
  components: {NewUser, EditUser, LinkPath},
  data: function () {
    return {
      listaUsuario: [],
      key: 'USERS',
      leftHand: false,
      leftHandReason: '',
      leftThumb: false,
      leftThumbReason: '',
      leftIndexFinger: false,
      leftIndexFingerReason: '',
      leftMiddleFinger: false,
      leftMiddleFingerReason: '',
      leftRingFinger: false,
      leftRingFingerReason: '',
      leftLittleFinger: false,
      leftLittleFingerReason: '',
      rightHand: false,
      rightHandReason: '',
      rightThumb: false,
      rightThumbReason: '',
      rightIndexFinger: false,
      rightIndexFingerReason: '',
      rightMiddleFinger: false,
      rightMiddleFingerReason: '',
      rightRingFinger: false,
      rightRingFingerReason: '',
      rightLittleFinger: false,
      rightLittleFingerReason: '',
      usuario: new Usuario()
    }
  },
  mounted() {
    this.listUsers()
  },
  methods: {
    toggleClassByName(className, id) {
      $(id).toggle(className)
    },
    check: function (action) {
      return roles.checkrole(window.localStorage.getItem('role'), this.key, action)
    },
    clearAlert: function () {
      $('.alert').hide()
      $('#divAlert').empty()
    },
    editUser: function (index) {
      this.clearReasons('all')
      this.usuario = this.listaUsuario[index]
      console.log(this.listaUsuario[index])
      if (this.usuario.exceptions) {
        for (let exc of this.usuario.exceptions) {
          if (exc.subType === 'LeftThumb') {
            this.leftThumb = true
            this.leftThumbReason = exc.exception
          }
          if (exc.subType === 'LeftIndexFinger') {
            this.leftIndexFinger = true
            this.leftIndexFingerReason = exc.exception
          }
          if (exc.subType === 'LeftMiddleFinger') {
            this.leftMiddleFinger = true
            this.leftMiddleFingerReason = exc.exception
          }
          if (exc.subType === 'LeftRingFinger') {
            this.leftRingFinger = true
            this.leftRingFingerReason = exc.exception
          }
          if (exc.subType === 'LeftLittleFinger') {
            this.leftLittleFinger = true
            this.leftLittleFingerReason = exc.exception
          }
          if (exc.subType === 'RightThumb') {
            this.rightThumb = true
            this.rightThumbReason = exc.exception
          }
          if (exc.subType === 'RightIndexFinger') {
            this.rightIndexFinger = true
            this.rightIndexFingerReason = exc.exception
          }
          if (exc.subType === 'RightMiddleFinger') {
            this.rightMiddleFinger = true
            this.rightMiddleFingerReason = exc.exception
          }
          if (exc.subType === 'RightRingFinger') {
            this.rightRingFinger = true
            this.rightRingFingerReason = exc.exception
          }
          if (exc.subType === 'RightLittleFinger') {
            this.rightLittleFinger = true
            this.rightLittleFingerReason = exc.exception
          }
        }
        if (this.rightThumb && this.rightIndexFinger && this.rightMiddleFinger && this.rightRingFinger && this.rightLittleFinger) {
          this.clearReasons('right')
          this.rightHand = true
          this.rightHandReason = this.usuario.exceptions[0].exception
        }
        if (this.leftThumb && this.leftIndexFinger && this.leftMiddleFinger && this.leftRingFinger && this.leftLittleFinger) {
          this.clearReasons('left')
          this.leftHand = true
          this.leftHandReason = this.usuario.exceptions[0].exception
        }
      }
      this.toggleClassByName('show', '#divUser')
      $('#newUser').hide()
      // var classe = $('#divUser').attr('class')
      // if (classe !== 'collapse in') {
      //   document.getElementById('divUser').click()
      // }
    },
    clearReasons: function (side) {
      if (side === 'left') {
        this.leftHand = false
        this.leftHandReason = ''
        this.leftThumb = false
        this.leftThumbReason = ''
        this.leftIndexFinger = false
        this.leftIndexFingerReason = ''
        this.leftMiddleFinger = false
        this.leftMiddleFingerReason = ''
        this.leftRingFinger = false
        this.leftRingFingerReason = ''
        this.leftLittleFinger = false
        this.leftLittleFingerReason = ''
      } else if (side === 'right') {
        this.rightHand = false
        this.rightHandReason = ''
        this.rightThumb = false
        this.rightThumbReason = ''
        this.rightIndexFinger = false
        this.rightIndexFingerReason = ''
        this.rightMiddleFinger = false
        this.rightMiddleFingerReason = ''
        this.rightRingFinger = false
        this.rightRingFingerReason = ''
        this.rightLittleFinger = false
        this.rightLittleFingerReason = ''
      } else {
        this.leftHand = false
        this.leftHandReason = ''
        this.leftThumb = false
        this.leftThumbReason = ''
        this.leftIndexFinger = false
        this.leftIndexFingerReason = ''
        this.leftMiddleFinger = false
        this.leftMiddleFingerReason = ''
        this.leftRingFinger = false
        this.leftRingFingerReason = ''
        this.leftLittleFinger = false
        this.leftLittleFingerReason = ''
        this.rightHand = false
        this.rightHandReason = ''
        this.rightThumb = false
        this.rightThumbReason = ''
        this.rightIndexFinger = false
        this.rightIndexFingerReason = ''
        this.rightMiddleFinger = false
        this.rightMiddleFingerReason = ''
        this.rightRingFinger = false
        this.rightRingFingerReason = ''
        this.rightLittleFinger = false
        this.rightLittleFingerReason = ''
      }
    },
    listUsers: function () {
      interceptor.request('get', 'api/v1/users', {})
        .then(response => {
          if (response.data) {
            this.listaUsuario = response.data
            // Chama o Data Table passando o arquivo de tradução e o mesmo monta os filtros da tabela
            this.$nextTick(() => {
              $('#tabUser').DataTable({
                'oLanguage': {
                  'sUrl': '/static/json/languageDataTable.json'
                }
              })
            })
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    clearUser() {
      this.clearAlert()
      this.clearReasons('all')
    }
  }
}
</script>

<style>
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}

@-webkit-keyframes v-gridStretchDelay {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes v-gridStretchDelay {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.button-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 1.2rem 12rem 1rem 0;
}

.btn-primary {
  background-color: #211858;
}
.btn-primary:hover {
  background-color: #7030C5;
}
.btn-primary:focus {
  background-color: #211858;
}
.btn-primary:disabled,
.btn-primary[disabled]{
  background-color: #7030C5;
}

.new-user-button {
  margin: 2px 0 0 0;
  padding: 8px 15px;
  background-color: #211858;
}

.toggle-button-cover {
  display: table-cell;
  position: relative;
  box-sizing: border-box;
}

.button-cover {
  background-color: transparent;
}

.button-cover,
.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.button-toggle {
  position: relative;
  top: 50%;
  width: 85px;
  height: 36px;
  margin: -20px auto 0 auto;
  overflow: hidden;
}

.button-toggle.r,
.button-toggle.r .layer {
  border-radius: 100px;
}

.button-toggle.b2 {
  border-radius: 2px;
}

.checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.knobs {
  z-index: 2;
}

.layer {
  width: 100%;
  background-color: #ebf7fc;
  transition: 0.3s ease all;
  z-index: 1;
}

/* Button 11 */
#button-11 {
  overflow: visible;
}

#button-11 .knobs {
  perspective: 70px;
}

#button-11 .knobs:before,
#button-11 .knobs:after,
#button-11 .knobs span {
  position: absolute;
  top: 4px;
  border-radius: 2px;
}

#button-11 .knobs:before,
#button-11 .knobs:after {
  width: 25px;
  height: 10px;
  color: #4e4e4e;
  font-size: 8px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 9px 4px;
}

#button-11 .knobs:before {
  content: "SHOW";
  left: 10px;
}

#button-11 .knobs:after {
  content: "HIDE";
  right: 4px;
}

#button-11 .knobs span {
  right: 4px;
  width: 33px;
  height: 28px;
  background-color: #7030C5;
  transform: rotateY(0);
  transform-origin: 0 50%;
  transition: 0.6s ease all;
  z-index: 1;
}

#button-11 .checkbox:checked + .knobs span {
  transform: rotateY(-180deg);
  background-color: #f44336;
}

#button-11 .checkbox:checked ~ .layer {
  background-color: #fcebeb;
}

.box-info {
  border-top-color: #7030C5 !important;
}
.form-control {
  border: lightslategrey solid 1px;
}
.form-check-input {
  border: grey solid 1px;
}
select input {
  border: lightslategrey solid 1px;
  border-radius: 2%;
}
</style>




// WEBPACK FOOTER //
// Users.vue?60ef036b